module.exports = __webpack_public_path__ + "img/pyatigorsk-place.9756a8c5.jpg";